<template>
  <div id="services" class="sec">
    <div class="MyContainer-fluid">
      <!-- <div class="title-center">
        <h1>Nuestros servicios</h1>
      </div>
      <p style="text-align: center;padding: 10px;">
        Nos ajustamos a las necesidades de nuestros clientes, desarrollando
        software,videojuegos y aplicaciones móviles a la medida.
      </p> -->
      <div class="MyContainer-fluid row">
        <div class="card">
          <div class="img">
            <img src="../../assets/webDev.svg" alt="" />
          </div>
          <div class="txtBox">
            <h3>Desarrollo web</h3>
          </div>
          <a href="/services">Ver más</a>
        </div>
        <div class="card">
          <div class="img">
            <img src="../../assets/MobilDev.svg" alt="" />
          </div>
          <div class="txtBox">
            <h3>Desarrollo mobil</h3>
          </div>
          <a href="/services">Ver más</a>
        </div>
        <div class="card">
          <div class="img">
            <img src="../../assets/gamin.svg" alt="" />
          </div>
          <div class="txtBox">
            <h3>Gamificación</h3>
          </div>
          <a href="/services">Ver más</a>
        </div>
        <div class="card">
          <div class="img">
            <img src="../../assets/computo.svg" alt="" />
          </div>
          <div class="txtBox">
            <h3>Comercialización equipos de computo</h3>
          </div>
          <a href="/services">Ver más</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="css" scoped>
.MyContainer-fluid {
  height: auto;
  width: 100%;
}

.MyContainer {
  height: auto;
  width: 90%;
  margin: 0 5%;
}

.MyContainer-fluid .title-center {
  background: var(--secondary);
  text-align: center;
  padding: 10px;
}

.MyContainer .title-center h1 {
  color: #fff;
}
.row {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
}

.row .card {
  margin: 25px 10px;
  position: relative;
  /* background: var(--back); */
  height: 50vh;
  width: 300px;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.row .card:hover {
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
}

.row .card:before {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  width: 50px;
  height: 100%;
  background: var(--secondary);
  transform-origin: top;
  transform: skewX(0deg) translate(-50%);
  z-index: 1;
}

.row .card .img {
  position: relative;
  padding: 25px;
  z-index: 10000;
  text-align: center;
}

.row .card .img img {
  height: 22vh;
}

.row .card .txtBox {
  position: relative;
  padding: 25px;
  z-index: 10000;
}

.row .card .txtBox h3 {
  color: var(--textColor);
}

.row .card a {
  position: absolute;
  bottom: -1;
  left: -1;
  border-top-left-radius: 10px;
  border: 1px solid var(--secondary);
  padding: 5px;
  background: var(--secondary);
  color: #fff;
  text-decoration: none;
  cursor: pointer;
  z-index: 10000;
}

.row .card a:hover {
  background: var(--primary);
}
</style>
